import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appNoData]',
  standalone: true,
})
export class BuyerPersonasNoDataDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
